import React from "react";
import kj1 from "../../../images/kj1.jpg";
import kj2 from "../../../images/kj2.jpg";
import kj3 from "../../../images/kj3.jpg";
import kj4 from "../../../images/kj4.jpg";
import kj5 from "../../../images/kj5.jpg";
import kj6 from "../../../images/kj6.jpg";
import kj7 from "../../../images/kj7.jpg";
import kj8 from "../../../images/kj8.jpg";
import kj9 from "../../../images/kj9.jpg";
import kj10 from "../../../images/kj10.jpg";
import EngagementCarouselPage from "../../ui/EngagementCarouselPage";

const KindnessJam = () => (
  <EngagementCarouselPage
    title="Kindness Jam"
    videos={["https://www.youtube.com/embed/zu00cK6ITek"]}
    paragraphs={[
      "To celebrate World Kindness Day in 2019, we put together our largest event at St.Andrews Auditorium that had performances by Ankur Tewari, the music Supervisor for Gully Boy, ONEmpire – the pop rock band and Aflatunes, the incredible acapella group. However to get tickets for the show, each person had to carry out an act of kindness. We organized volunteering events with Connect.for which you could attend and get a ticket. That's it. No cash, no credit, only kindness!",
    ]}
    images={[kj1, kj2, kj3, kj4, kj5, kj6, kj7, kj8, kj9, kj10]}
  />
);

export default KindnessJam;
